import React from 'react';
// import "./format4.css"

const Format4 = ({ modifyForm  }) => {
 

  return (
  <div className="sheet-content __invTemplate4">
  <section className="sheet padding-2mm_inv4">
    <div id="printableArea221">
      <table className="__mainTab_reps" cellPadding="0" cellSpacing="0">
        <tbody>
          <tr>
            <td>
              <table style={{ width: '100%', borderBottom: '2px solid #000' }}>
                <thead>
                  <tr>
                    <th align="center" style={{ fontSize: '18px', padding: '4px', fontWeight: '600',textAlign:"center" }}>
                      {"CHOUBEY LOGISTICS PRIVATE LIMITED"}
                    </th>
                  </tr>
                </thead>
              </table>
            </td>
          </tr>

          <tr>
            <td style={{ paddingTop: '5px' }}>
              <table className="__inlineTables">
                <tbody>
                  <tr>
                    <td align="center">
                      <p>{"PLOT NO. 259, P K V SOCIETY, KATOL ROAD BY PASS, DHABA NAGPUR - 440023"}</p>
                      <p>{"PH.: (0) 9823166667, 9372268000"}</p>
                      <p>{"GSTIN: 27AALCC9434G1ZD"}</p>
                      <p>{`FOR THE FINANCIAL YEAR ${modifyForm.financial_year || "2024-2025"}`}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td style={{ paddingTop: '10px' }}>
              <table className="__inlineTables">
                <tbody>
                  <tr>
                    <td style={{ paddingLeft: '5px' }}>
                      <p>{"GOPAL SNACKS LIMITED"}</p>
                      <p>{"NAGPUR"}</p>
                      <p>{"GSTIN: 27AADC66113A1Z7"}</p>
                      <br />
                      <p>{"GSL/24-25/01"}</p>
                      <p>HSN/SAC CODE: 996511</p>
                    </td>
                    <td style={{ textAlign: 'right', paddingRight: '10px', verticalAlign: 'bottom' }}>
                      <p>{"00.00.0000"}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td style={{ paddingTop: '12px' }}>
              <table className="__vehTable">
                <thead>
                  <tr>
                    <th align="left">{"SR NO"}</th>
                    <th>{"LR NO"}</th>
                    <th>TRUCK NO</th>
                    <th>TYPE OF<br /> VEHICLE</th>
                    <th>{"DATE"}</th>
                    <th>FROM LOCATION</th>
                    <th>TO LOCATION</th>
                    <th>PKG</th>
                    <th>FREIGHT</th>
                    <th>TOTAL</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td><p></p></td>
                    <td><p></p></td>
                    <td><p></p></td>
                    <td><p></p></td>
                    <td><p></p></td>
                    <td><p></p></td>
                    <td><p></p></td>
                    <td><p></p></td>
                    <td align="right"><p></p></td>
                    <td align="right"><p></p></td>
                  </tr>
                </tbody>

                <tfoot>
                  <td align="left" colSpan="7">INWORDS RS. :</td>
                  <td>TOTAL RS.</td>
                  <td align="right">-</td>
                  <td align="right">-</td>
                </tfoot>
              </table>
            </td>
          </tr>

          <tr>
            <td style={{ paddingTop: '15px' }}>
              <p style={{ fontSize: '11.5px', margin: '0', borderTop: '1px solid #000', padding: '2px' }}>
                {modifyForm?.static_fields.line1 || `We hereby certify that input tax credit or inputs, input services and capital goods use for providing
                services of`}
              </p>
              <p
                style={{
                  fontSize: '11.5px',
                  margin: '0',
                  borderTop: '1px solid #000',
                  padding: '2px',
                  borderBottom: '1px solid #000',
                }}
              >
               {modifyForm?.static_fields.line2 ||` GST ON GOODS TRANSPORT AGENCY IS APPLICABLE ON REVERSE CHARGES BASIS.`}
              </p>
            </td>
          </tr>

          <tr>
            <td>
              <table className="__tfooterTab">
                <tbody>
                  <tr>
                    <td align="center">
                      <div>
                        <p>{modifyForm.prepared_by || "MR. SHUBHAM PANDEY"}</p>
                      </div>{' '}
                      <strong>PREPARED BY</strong>
                    </td>
                    <td align="center" style={{ width: '30%' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <p>{modifyForm.verified_by || "MR. VIRENDRA"}</p>
                      </div>{' '}
                      <strong>VERIFIED BY</strong>
                    </td>
                    <td style={{ width: '30%', padding: '0px 10px 10px 10px' }} align="right">
                      <strong>AUTHORISE SIGNATORY</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  {/* CSS remains the same as in your original code */}
  <style>
    {`
    /* Note: Necessary for the pdf */
    @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

    body {
      margin: 0px;
      font-family: "Roboto", sans-serif;
    }

    @page {
      margin: 0px;
    }

    .__invTemplate4 .__mainTab_reps {
      width: 100%;
      border: 2px solid #000;
      margin-bottom: 10px;
    }

    .__invTemplate4 .__inlineTables {
      width: 100%;
      border-collapse: collapse;
    }

    .__invTemplate4 .__inlineTables p {
      font-size: 11.6px;
      font-weight: 600;
      margin: 0px;
      line-height: 17px;
    }

    .__invTemplate4 .__vehTable {
      width: 100%;
      border-collapse: collapse;
    }

    .__invTemplate4 .__vehTable th,
    .__invTemplate4 .__vehTable td {
      font-size: 11.6px;
      border: 1px solid #000;
      padding: 5px 5px;
    }

    .__invTemplate4 .__vehTable th:nth-child(1),
    .__invTemplate4 .__vehTable td:nth-child(1) {
      border-left: none;
    }

    .__invTemplate4 .__vehTable th:last-child,
    .__invTemplate4 .__vehTable td:last-child {
      border-right: none;
    }

    .__invTemplate4 .__vehTable td p {
      margin: 0;
      min-height: 16px;
    }

    .__invTemplate4 .__vehTable tfoot td {
      font-weight: 600;
    }

    .__invTemplate4 .__tfooterTab {
      width: 100%;
      min-height: 100px;
    }

    .__invTemplate4 .__tfooterTab td {
      font-size: 12px;
      vertical-align: bottom;
    }

    .__invTemplate4 .__tfooterTab td p {
      margin: 0px;
      line-height: 20px;
    }

    .__invTemplate4 .sheet.padding-2mm_inv4 {
      padding: 2mm;
      background: white;
      page-break-after: always;
    }

    .__invTemplate4 .sheet.padding-2mm_inv4:last-child {
      page-break-after: auto;
    }

    .sheet-content.__invTemplate4 {
      transform-origin: top left;
      transition: transform 0.2s ease;
      width: 210mm;
      margin: 0 auto;
    }

    @media (max-width: 319px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(20% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 320px) and (max-width: 339px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(20% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 340px) and (max-width: 359px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(20% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 360px) and (max-width: 379px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(22% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 380px) and (max-width: 399px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(24% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 400px) and (max-width: 419px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(26% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 420px) and (max-width: 439px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(26% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 440px) and (max-width: 459px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(28% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 460px) and (max-width: 479px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(28.6% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 480px) and (max-width: 499px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(30% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 500px) and (max-width: 519px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(30% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 520px) and (max-width: 539px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(30% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 540px) and (max-width: 559px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(33.6% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 560px) and (max-width: 579px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(35% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 580px) and (max-width: 599px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(36% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 600px) and (max-width: 629px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(37.5% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 630px) and (max-width: 669px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(38.6% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 670px) and (max-width: 699px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(42% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 700px) and (max-width: 739px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(44% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 740px) and (max-width: 769px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(46% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (min-width: 770px) and (max-width: 799px) {
      .sheet-content.__invTemplate4 {
        transform: scale(calc(48% * 2)) !important;
        transform-origin: 5px 0px;
      }
    }

    @media (max-width: 767px) {
      .sheet-content.__invTemplate4 {
        margin: 0 auto;
      }
    }

    @media print {
      .sheet-content.__invTemplate4 {
        transform: scale(1) !important;
        width: 210mm;
      }

      .__invTemplate4 .sheet.padding-2mm_inv4 {
        padding: 2mm;
      }

      @page {
        margin: 0px;
        size: A4 portrait;
      }
    }
    `}
  </style>
</div>
  );
};

export default Format4;